
import React, { createContext, useContext, useState, useEffect } from 'react';
import { getAccountByHostname } from '@/lib/supabase-client';

export type Account = {
  id: string;
  name: string;
  logo?: string;
  configs?: {
    shippingFee?: number;
    freeShippingThreshold?: number;
    logo?: string;
    address?: string;
    phone?: string;
    email?: string;
    facebook?: string;
    instagram?: string;
    paymentMethods?: string[];
    shippingOptions?: string[];
  };
  [key: string]: unknown;
};

const AccountContext = createContext<{ account: Account } | undefined>(undefined);

const DEFAULT_ACCOUNT: Account = {
  id: '',
  name: 'Store',
};

export const AccountProvider = ({
  children,
  account: initialAccount,
}: {
  children: React.ReactNode;
  account?: Account;
}) => {
  const [account, setAccount] = useState<Account>(initialAccount || DEFAULT_ACCOUNT);

  useEffect(() => {
    const fetchAccount = async () => {
      try {
        const hostname = window.location.hostname;
        const { data, error } = await getAccountByHostname(hostname);
        if (data && !error) {
          setAccount(data as unknown as Account);
        }
      } catch {
        // Account not found, use default
      }
    };

    fetchAccount();
  }, []);

  return <AccountContext.Provider value={{ account }}>{children}</AccountContext.Provider>;
};

export const useAccount = () => {
  const context = useContext(AccountContext);
  if (context === undefined) {
    throw new Error('useAccount must be used within an AccountProvider');
  }
  return context;
};
